export default __webpack_public_path__ + "static/media/information-1.6e1dcdb1.jpg";